angular.module('dwtModule').factory('viewDwtClaimDetailModal', [
  'ViewDwtDetailService',
  function (ViewDwtDetailService) {
    function viewDwtClaimDetailModal(data, userType) {
      this.claimOverviewList = (data.claimOverviewList || []).map(function (overview) {
        if (!overview || typeof overview !== 'object') {
          return overview;
        }

        var normalizedOverview = angular.copy(overview);
        normalizedOverview.peclaimsCount =
          overview.peclaimsCount || overview.PEClaimsCount;
        normalizedOverview.qrfclaimsCount =
          overview.qrfclaimsCount || overview.QRFClaimsCount;

        return normalizedOverview;
      });
      this.peClaims = data.peClaims;
      this.qrfClaims = data.qrfClaims;
      this.isin = data.isin;
      this.currency = data.currency;
      this.peEnabled = data.peEnabled;
      if (userType !== 'AG') {
        this.qrfAmount = data.qrfAmount;
        this.peAmount = data.peAmount;
        this.totalAmount = data.totalAmount;
      }
    }
    return viewDwtClaimDetailModal;
  },
]);
